export enum AccountStatus {
  blank = 'blank',
  cancelled = 'cancelled',
  customer = 'customer',
  delete = 'delete',
  demo = 'demo',
  sandbox = 'sandbox',
  suspended = 'suspended',
  test = 'test',
}
